var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Toast'), _c('div', {
    staticClass: "flex items-center w-full p-3 my-3 bg-white rounded-lg shadow-sm"
  }, [_c('router-link', {
    staticClass: "text-lg font-medium text-gray-900 hover:text-blue-600",
    attrs: {
      "to": "/vendor"
    }
  }, [_vm._v(" Publisher ")]), _c('div', {
    staticClass: "px-3 text-gray-400"
  }, [_vm._v(" • ")]), _c('router-link', {
    staticClass: "text-lg font-medium text-gray-900 hover:text-blue-600",
    attrs: {
      "to": ("/vendor/edit/" + (_vm.$route.params.id) + "?tab=2")
    }
  }, [_vm._v(" Publisher Agreement ")])], 1), _c('div', {
    staticClass: "flex-col w-full mb-3 bg-white rounded-lg"
  }, [_c('div', {
    staticClass: "flex items-center justify-between w-full px-4 py-3 mt-3 rounded-lg"
  }, [_c('div', {
    staticClass: "flex flex-col w-1/2"
  }, [_c('FormLabel', {
    attrs: {
      "htmlFor": "currency"
    }
  }, [_vm._v(" Payment Currency ")]), _c('SelectRadio', {
    attrs: {
      "id": "currency",
      "defaultText": "Select Payment Currency",
      "options": _vm.currencyOptions,
      "isError": _vm.isVACurrencyError
    },
    model: {
      value: _vm.form.vACurrency,
      callback: function ($$v) {
        _vm.$set(_vm.form, "vACurrency", $$v);
      },
      expression: "form.vACurrency"
    }
  }), _vm.isVACurrencyError ? _c('p', {
    staticClass: "mt-1 text-sm text-red-500"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _c('FormLabel', {
    staticClass: "mt-3",
    attrs: {
      "htmlFor": "revenue"
    }
  }, [_vm._v(" Revenue Share ")]), _c('multiselect', {
    staticClass: "box-border",
    attrs: {
      "label": "name",
      "track-by": "name",
      "placeholder": "type to find name of revenue share...",
      "open-direction": "bottom",
      "options": _vm.revenueItems,
      "searchable": true,
      "loading": _vm.isLoadingSearchRevenue,
      "close-on-select": true
    },
    on: {
      "search-change": _vm.findRevenue,
      "select": _vm.selectRevenue
    },
    model: {
      value: _vm.form.vARevenue,
      callback: function ($$v) {
        _vm.$set(_vm.form, "vARevenue", $$v);
      },
      expression: "form.vARevenue"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v(" Oops! No elements found. Consider changing the search query. ")])]), _vm.isVARevenueError ? _c('p', {
    staticClass: "mt-1 text-sm text-red-500"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _c('DatetimeCustom', {
    staticClass: "mt-3",
    attrs: {
      "timeOnlyHours": true,
      "label": 'Start Date'
    },
    model: {
      value: _vm.form.vAStartDate,
      callback: function ($$v) {
        _vm.$set(_vm.form, "vAStartDate", $$v);
      },
      expression: "form.vAStartDate"
    }
  }), _vm.isVAStartDateError ? _c('p', {
    staticClass: "mt-1 text-sm text-red-500"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _c('DatetimeCustom', {
    staticClass: "mt-3",
    attrs: {
      "timeOnlyHours": true,
      "label": 'End Date'
    },
    model: {
      value: _vm.form.vAEndDate,
      callback: function ($$v) {
        _vm.$set(_vm.form, "vAEndDate", $$v);
      },
      expression: "form.vAEndDate"
    }
  }), _vm.isVAEndDateError ? _c('p', {
    staticClass: "mt-1 text-sm text-red-500"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _vm.isDateRangeError ? _c('p', {
    staticClass: "mt-1 text-sm text-red-500"
  }, [_vm._v("End date must be greater than start date.")]) : _vm._e(), _c('FormLabel', {
    attrs: {
      "htmlFor": "status",
      "className": "mt-3"
    }
  }, [_vm._v(" Status ")]), _c('GmSwitch', {
    attrs: {
      "id": "status"
    },
    model: {
      value: _vm.form.vAIsActive,
      callback: function ($$v) {
        _vm.$set(_vm.form, "vAIsActive", $$v);
      },
      expression: "form.vAIsActive"
    }
  }), _c('FormLabel', {
    attrs: {
      "className": "mt-3",
      "disabled": ""
    }
  }, [_vm._v(" Default Fixed Amount ")]), _c('TextInput', {
    staticClass: "text-gray-400",
    attrs: {
      "type": "text",
      "id": "defaultFixed",
      "disabled": "",
      "value": _vm.defaultFixed || '-'
    }
  }), _c('FormLabel', {
    attrs: {
      "className": "mt-3",
      "disabled": ""
    }
  }, [_vm._v(" Default Percentage Amount ")]), _c('TextInput', {
    staticClass: "text-gray-400",
    attrs: {
      "type": "text",
      "id": "defaultPercentage",
      "disabled": "",
      "value": _vm.defaultPercentage || '-'
    }
  }), _c('div', {
    staticClass: "flex gap-5 mt-4"
  }, [_c('Button', {
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(" Save ")]), _c('Button', {
    attrs: {
      "variant": "outlined",
      "color": "alternative"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(" Cancel ")])], 1)], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }